import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { withTranslation } from "react-i18next";
import "flatpickr/dist/themes/material_blue.css";
import { isEmpty, map, size } from "lodash";
import DeleteModal from "../../components/Common/DeleteModal";
import {
  addContactLevel,
  getContactLevel,
  updateContactLevel,
  deleteContactLevel,
} from "../../store/actions";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
} from "reactstrap";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import SafeField from "helpers/SafeField";

const ContactLevel = props => {
document.title = "General Settings | Contact Level";

  const dispatch = useDispatch();
  

  const { levels, loading } = useSelector(state => ({
    levels: state.ObjectReducer.levels,
    loading: state.ObjectReducer.loading,
  }));

  const [level, setLevel] = useState({});
  const [isRight, setIsRight] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  /* -------------------- API Calls -------------------- */

  useEffect(() => {
    dispatch(getContactLevel(localStorage.getItem("userId")));
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(levels)) {
      setIsEdit(false);
    }
  }, [levels]);

  /* -------------------- Handlers -------------------- */

  const toggle = () => setIsRight(!isRight);

  const toggleRightCanvas = selectedLevel => {
    if (selectedLevel) {
      setLevel({
        id: selectedLevel.id,
        contactLevelId: selectedLevel.contactLevelId,
        contactLevelTitle: selectedLevel.contactLevelTitle,
        agentId: selectedLevel.agentId,
      });
      setIsEdit(true);
    } else {
      setLevel({});
      setIsEdit(false);
    }
    toggle();
  };

  const handleContactLevelSubmit = values => {
    dispatch(addContactLevel(values, history));
  };

  const onClickDelete = selectedLevel => {
    setLevel(selectedLevel);
    setDeleteModal(true);
  };

  const handleDeleteContactLevel = () => {
    if (level?.id) {
      dispatch(deleteContactLevel(level));
      setDeleteModal(false);
    }
  };

  /* -------------------- Render -------------------- */

  return (
    <>
      {loading && <div className="loading">Loading…</div>}
      <ToastContainer autoClose={2000} />

      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteContactLevel}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
       
        <Container fluid>
          <Row className="mb20">
            <Col xl="12">
              <Breadcrumbs
                title={props.t("General Settings")}
                breadcrumbItem={props.t("Contact Level")}
              />
            </Col>
          </Row>

          <Row>
            

            <Col xl="12">
              {/* ---------------- Add Form ---------------- */}
              <Formik
                enableReinitialize
                initialValues={{ contactLevelTitle: "" }}
                validationSchema={Yup.object({
                  contactLevelTitle: Yup.string().required("This is required"),
                })}
                onSubmit={handleContactLevelSubmit}
              >
                {({ errors, touched, handleChange }) => (
                  <Form className="needs-validation">
                    <Card>
                      <CardBody>
                        
                        <Row>
                          <Col sm="3">
                            <FormGroup className="mb-3">
                              <Label>Title *</Label>
                              <SafeField
                                name="contactLevelTitle"
                                onChange={handleChange}
                                type="text"
                                className={
                                  "form-control" +
                                  (errors.contactLevelTitle &&
                                  touched.contactLevelTitle
                                    ? " is-invalid"
                                    : "")
                                }
                              />
                              <ErrorMessage
                                name="contactLevelTitle"
                                component="div"
                                className="invalid-feedback"
                              />
                            </FormGroup>
                          </Col>

                          <Col sm="2">
                            <button
                              type="submit"
                              className="btn btn-primary w-md"
                              style={{ marginTop: 31 }}
                            >
                              Add
                            </button>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>

                    {/* ---------------- History Table ---------------- */}
                    <Card>
                      <CardBody>
                        <h5 className="card-title">History</h5>
                        <div className="table-responsive">
                          <table className="table table-bordered align-middle table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Title</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {map(levels, (item, index) => (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{item.contactLevelTitle}</td>
                                  <td>
                                    <ActionEdit
                                      onClick={() =>
                                        toggleRightCanvas(item)
                                      }
                                    />
                                    <ActionDelete
                                      onClick={() => onClickDelete(item)}
                                    />
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>

          {/* ---------------- Update Offcanvas ---------------- */}
          <Offcanvas isOpen={isRight} direction="end" toggle={toggle}>
            <OffcanvasHeader toggle={toggle}>Update</OffcanvasHeader>
            <OffcanvasBody>
              <Formik
                enableReinitialize
                initialValues={{
                  id: level?.id,
                  contactLevelId: level?.contactLevelId,
                  contactLevelTitle: level?.contactLevelTitle || "",
                  agentId: level?.agentId,
                }}
                validationSchema={Yup.object({
                  contactLevelTitle: Yup.string().required("This is required"),
                })}
                onSubmit={values => {
                  if (isEdit) {
                    dispatch(updateContactLevel(values));
                  }
                  toggle();
                }}
              >
                {({ errors, touched, handleChange }) => (
                  <Form className="needs-validation">
                    <Row>
                      <Col sm="12">
                        <FormGroup className="mb-3">
                          <Label>Title *</Label>
                          <SafeField
                            name="contactLevelTitle"
                            onChange={handleChange}
                            type="text"
                            className={
                              "form-control" +
                              (errors.contactLevelTitle &&
                              touched.contactLevelTitle
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="contactLevelTitle"
                            component="div"
                            className="invalid-feedback"
                          />
                        </FormGroup>
                      </Col>

                      <Col sm="12">
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                        >
                          Update
                        </button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </OffcanvasBody>
          </Offcanvas>
        </Container>
      </div>
    </>
  );
};

export default withTranslation()(ContactLevel);
